import { AuthContext } from 'alurkerja-ui'
import axios from 'axios'
import { useContext } from 'react'

export const useEditor = () => {
  const axiosInstance = useContext(AuthContext)

  const uploadImageForEditor = async (file: File, withoutToken = true) => {
    const url = 'https://n8n.merapi.javan.id/webhook/e1cc9b23-6595-4bb5-bd28-da934b5d26b2'
    const formData = new FormData()
    formData.append('upload', file)

    if (withoutToken) {
      return axios
        .post(url, formData, {
          headers: { 'Content-Type': 'multipart/form-data' },
        })
        .then((res) => {
          if (res.status === 200) {
            const url = res.data.url
            return { data: { url } }
          }
        })
    }

    return axiosInstance
      .post(url, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      })
      .then((res) => {
        if (res.status === 200) {
          const url = res.data.url
          return { data: { url } }
        }
      })
  }

  return { uploadImageForEditor }
}
